import { Grid, TextField, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import * as React from "react";
import { Protocol } from "../../../model/device";
import { processValue } from "../../../scripts/utils";
import { getTypeAlias } from "../../../model/device";
import { useParams } from "react-router-dom";
import useBackend from "../../../hooks/use_backend";
import { useState } from "react";

export const AddableResultSelect = ({ addableResults, selResult, setSelResult }) => {
  return (
    <Box pl={2} display="flex">
      <FormControl>
        <InputLabel id="demo-simple-select-label">Discovered device</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selResult}
          label="Age"
          onChange={(e) => {
            setSelResult(e.target.value);
          }}
        >
          {Object.entries(addableResults).map(([key, val]) => {
            return (
              <MenuItem key={key} value={key}>
                {getTypeAlias(val.device.device_type)} - {val.device.address}
                {val.device.protocol !== Protocol.RS485 ? ":" + val.device.port : ""} [{val.device.slave}]
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export const ProbeDeviceAdd = ({ device, setDevice, existing, newGPCPrice, setNewGPCPrice }) => {
  const backend = useBackend();
  const params = useParams();

  function handleDevChange(field, value, isString = false) {
    const processed = processValue(value, isString);
    setDevice((prev) => {
      const updated = { ...prev };
      updated[field] = processed;
      return updated;
    });
  }
  if (device === null || device === undefined) return null;
  return (
    <Grid mt={2} container justifyContent="start">
      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      >
        <TextField
          autoFocus
          label="Give the device a name"
          fullWidth
          value={device.name || ""}
          onChange={(e) => handleDevChange("name", e.target.value, true)}
        />
      </Grid>

      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      />

      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      >
        <TextField disabled label="Device class" fullWidth value={device.device_class} />
      </Grid>

      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      >
        <TextField disabled label="Device type" fullWidth value={device.device_type} />
      </Grid>

      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      >
        <TextField disabled label="Address" fullWidth value={device.address} />
      </Grid>

      <Grid
        md={6}
        xs={12}
        item
        width={"80%"}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        px={2}
        py={2}
      >
        <TextField disabled label="Modbus slave" fullWidth value={device.slave} />
      </Grid>

      {device.device_class === "battery" && (
        <>
          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Enter the capacity of the battery (Wh)"
              fullWidth
              value={device.capacity || ""}
              onChange={(e) => handleDevChange("capacity", e.target.value, true)}
            />
          </Grid>

          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Enter the charge rate of the battery (W)"
              fullWidth
              value={device.charge_rate || ""}
              onChange={(e) => handleDevChange("charge_rate", e.target.value, true)}
            />
          </Grid>

          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Minimum SOC (%)"
              fullWidth
              type="number"
              inputProps={{ min: 0, max: 100 }}
              value={device.minimum_soc ?? ""}
              onChange={(e) => handleDevChange("minimum_soc", e.target.value, false)}
              onBlur={(e) => {
                const val = parseInt(e.target.value);
                if (isNaN(val) || val < 0) handleDevChange("minimum_soc", 0, false);
                else if (val > 100) handleDevChange("minimum_soc", 100, false);
              }}
              helperText="Range: 0% - 100%"
            />
          </Grid>

          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Maximum SOC (%)"
              fullWidth
              type="number"
              inputProps={{ min: 0, max: 100 }}
              value={device.maximum_soc ?? ""}
              onChange={(e) => handleDevChange("maximum_soc", e.target.value, false)}
              onBlur={(e) => {
                const val = parseInt(e.target.value);
                if (isNaN(val) || val < 0) handleDevChange("maximum_soc", 0, false);
                else if (val > 100) handleDevChange("maximum_soc", 100, false);
              }}
              helperText="Range: 0% - 100%"
            />
          </Grid>
        </>
      )}
      {device.device_class === "solar_inverter" && (
        <>
          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Enter the inverter power of the solar inverter (W)"
              fullWidth
              value={device.inverter_power || ""}
              onChange={(e) => handleDevChange("inverter_power", e.target.value, true)}
            />
          </Grid>
          <Grid
            md={6}
            xs={12}
            item
            width={"80%"}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            px={2}
            py={2}
          >
            <TextField
              label="Green power certificate (0 if none)"
              fullWidth
              value={newGPCPrice}
              onChange={(e) => setNewGPCPrice(e.target.value)}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
